import { render, staticRenderFns } from "./global-notification-list.html?vue&type=template&id=5cc9546a&scoped=true&external"
import script from "./global-notification-list.js?vue&type=script&lang=js&external"
export * from "./global-notification-list.js?vue&type=script&lang=js&external"
import style0 from "./global-notification-list.scss?vue&type=style&index=0&id=5cc9546a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc9546a",
  null
  
)

export default component.exports